module.exports = __webpack_public_path__ + "img/live-ys-gif.8c22bd3a.gif";